export function isNumeric(numberObj) {    
  return !isNaN(parseFloat(numberObj)) && isFinite(numberObj);
}